import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7510cd8295d50014d2aa3d_1788967521920_e9051ae6/cards247/src/app/not-found.tsx");
